/* eslint-disable tailwindcss/no-custom-classname */
import clsx from 'clsx'
import { useNavigate, useParams } from 'react-router-dom'
import { FileNavLink } from '../FileNavLink/FileNavLink'
import styles from './FileBreadCrumb.module.scss'
export interface FileBreadCrumbSearchProps {
  handleCloseSearchInput?: () => void
  query?: string
}

export function FileBreadCrumbSearch({
  handleCloseSearchInput,
  query: defaultQuery = '',
}: FileBreadCrumbSearchProps) {
  const { query = defaultQuery } = useParams()
  const navigate = useNavigate()
  return (
    <nav className={styles.breadcrumb}>
      <FileNavLink
        context="search"
        // This disables the default .active class set by react router
        className={() => styles.item}
        onClick={e => {
          e.preventDefault()
          if (handleCloseSearchInput) {
            handleCloseSearchInput()
          }
          navigate(-1)
        }}
      />
      <span className={clsx(styles.item, 'active')}>{query}</span>
    </nav>
  )
}
